import React, { useState, useEffect } from "react";
import { usePathname } from "next/navigation";
import { MAP_LABELS } from "@/utils/helper";
import { useRouter } from "next/router";
import styles from "./index.module.scss";
import Link from "next/link";
import ChatPopup from "@/components/ChatBox";
import Image from "next/image";
import chatCancel from "@/assets/chat/chatCancel.png";

const Chat = ({ chatUrl = "", chatList = [] }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const { locale } = useRouter();
  const pathname = usePathname();
  useEffect(() => {
    setIsChatOpen(false);
  }, [pathname]);

  const chatContent = (
    <>
      <span className="icon koh-icon-envelope" />
      <span className="chat-btn-text">Chat</span>
    </>
  );

  return (
    <>
      <ChatPopup
        isOpen={isChatOpen}
        chatList={chatList}
        onClose={() => setIsChatOpen(false)}
      />
      <div className={`${styles.wrapper} print:hidden`}>
        <Link className="koh-fixed-find-store-btn" href="/storelocator">
          <span className="icon koh-icon-envelope"></span>
          <span className="find-store-text">
            {MAP_LABELS[locale]?.searchLabel}
          </span>
        </Link>

        {isChatOpen ? (
          <div
            className="kohWhatsAppBtnchatting"
            onClick={() => setIsChatOpen(prev => !prev)}
          >
            <Image
              src={chatCancel?.src}
              alt={"label"}
              width={50}
              height={50}
              className=" image-parts"
            />
          </div>
        ) : (
          <div
            className="kohWhatsAppBtn cursor-pointer"
            onClick={() => !chatUrl && setIsChatOpen(prev => !prev)}
          >
            {chatUrl ? (
              <a className="kohWhatsAppBtn" href={chatUrl} target="_blank">
                {chatContent}
              </a>
            ) : (
              chatContent
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Chat;
